import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Warning, Checkmark } from '../icons';
import './FormFeedback.scss';

const FormFeedback = ({ children = '', positive = true }) => {
  
  const containerClasses = classNames('form-feedback', {
    'form-feedback--positive': positive,
    'form-feedback--negative': !positive
  });

  // 3. Logic to determine wrapper element
  const isList = Array.isArray(children);
  const WrapperTag = isList ? 'ul' : 'span';

  return (
    <div className={containerClasses}>
      <div className="form-feedback__icon">
        {positive ? (
          <Checkmark width="2.4rem" height="2.4rem" />
        ) : (
          <Warning width="2.4rem" height="2.4rem" />
        )}
      </div>

      {/* 4. Render children inside the dynamic wrapper */}
      <WrapperTag className="form-feedback__text">
        {children}
      </WrapperTag>
    </div>
  );
};

FormFeedback.propTypes = {
  children: PropTypes.node,
  positive: PropTypes.bool
};

export default FormFeedback;
